export const REQUEST_PERIOD_OVERLAP_TYPE = {
  PARTIAL: 'PARTIAL',
  FULL: 'FULL',
  NONE: 'NONE'
};
